import React, { FC, InputHTMLAttributes } from 'react'

export interface RadioButtonProps extends InputHTMLAttributes<HTMLInputElement> {
    isChecked?: boolean;
    label?: string;
    onChange?: (isChecked: any) => void;
    labelClassName?: string;
    iconWrapperClassName?: string;
    isNegative?: boolean;
}


const QualityButton: FC<RadioButtonProps> = ({ isNegative = false, labelClassName, onChange, isChecked, label, children, ...rest }) => {

    return (
        // <button

        //     className={`border 
        //     ${isNegative
        //             ? 'border-[#F45B69] text-[#F45B69]'
        //             : 'border-[#2CC95B] text-[#2CC95B]'
        //         } rounded-lg bg-white  text-xs font-inter-bold flex items-center justify-center w-[65px] h-[30px]`}>
        //     {children}
        // </button>
        <label
            htmlFor={rest.id}
            className={`${labelClassName} cursor-pointer border rounded-lg bg-white  text-xs font-inter-bold flex items-center justify-center w-[65px] h-[30px] ${isChecked
                ? isNegative
                    ? ` !bg-[#F45B69] text-[#fff] border-[#F45B69]`
                    : ` !bg-[#2CC95B] text-[#fff] border-[#2CC95B]`
                : isNegative
                    ? "border-[#F45B69] text-[#F45B69]"
                    : "border-[#2CC95B] text-[#2CC95B]"
                } `}
        >
            {label}
            <input
                type="radio"
                className={`${rest.className} hidden`}
                id={rest.id}
                checked={isChecked}
                name={rest?.name || "bordered-radio"}
                onChange={onChange}
            />
            {children}
        </label>
    )
}

export default QualityButton